module.exports = __webpack_public_path__ + "8e43ad9e6e20cd7898be277c36bab44f.svg";